import { useCallback, useEffect, useState } from "react";
import { Loader2, Store } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { EmptyState } from "@/components/common";
import { api, errMsg, fmtDate, maskDoc, maskPhone } from "@/lib/api";
import { cn } from "@/lib/utils";

const addr = (a) => [[a.street, a.number].filter(Boolean).join(", "), a.district, [a.city, a.state].filter(Boolean).join("/")].filter(Boolean).join(" - ");

export function MerchantsTab() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const load = useCallback(() => api.get("/boy/merchants").then((r) => setRows(r.data)).catch(() => {}), []);
  useEffect(() => {
    load();
  }, [load]);
  const toggle = async (m) => {
    try {
      await api.patch(`/boy/merchants/${m.id}`, { active: !m.active });
      toast.success(m.active ? `${m.name} desativado` : `${m.name} ativado`);
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  if (!rows) return <p className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin" /></p>;
  const term = q.trim().toLowerCase().replace(/\D/g, "") || q.trim().toLowerCase();
  const list = rows.filter((m) => !q.trim() || `${m.name} ${m.document} ${m.phone}`.toLowerCase().includes(term));
  return (
    <div className="space-y-4" data-testid="boy-merchants-tab">
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar por nome, CPF/CNPJ ou telefone" className="sm:w-80" data-testid="boy-merchants-search" />
      {!list.length ? <EmptyState icon={Store} title="Nenhum lojista" text="Os lojistas que se cadastrarem pelo link aparecem aqui e já podem pedir entregas." /> : (
        <div className="grid gap-3">
          {list.map((m) => (
            <div key={m.id} className="card-surface flex flex-col gap-3 p-4 sm:flex-row sm:items-center" data-testid={`boy-merchant-${m.id}`}>
              <div className="min-w-0 flex-1 space-y-1">
                <div className="flex flex-wrap items-center gap-2"><p className="font-semibold">{m.name}</p>
                  <span className={cn("rounded-full px-2 py-0.5 text-xs font-semibold", m.active ? "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300" : "bg-muted text-muted-foreground")}>{m.active ? "Ativo" : "Inativo"}</span>
                  <span className="text-xs text-muted-foreground">{m.rides} corrida(s)</span></div>
                <p className="text-xs text-muted-foreground">{maskDoc(m.document)} · Tel. {maskPhone(m.phone)} · WhatsApp {maskPhone(m.whatsapp)} · desde {fmtDate(m.created_at)}</p>
                <p className="truncate text-xs text-muted-foreground">{addr(m.address || {})}</p>
              </div>
              <Button size="sm" variant="outline" onClick={() => toggle(m)} data-testid={`boy-merchant-toggle-${m.id}`}>{m.active ? "Desativar" : "Ativar"}</Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
